var React = require('react');

function UploadDocument (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 9V71H49.6367C52.2383 76.3203 57.6875 80 64 80C72.8242 80 80 72.8242 80 64C80 55.5117 73.3594 48.5703 65 48.0508V23.5859L50.4141 9H15ZM17 11H49V25H63V48.0508C54.6406 48.5703 48 55.5117 48 64C48 65.7461 48.2891 67.4258 48.8125 69H17V11ZM51 12.4141L61.5859 23H51V12.4141ZM64 50C71.7422 50 78 56.2578 78 64C78 71.7422 71.7422 78 64 78C56.2578 78 50 71.7422 50 64C50 56.2578 56.2578 50 64 50ZM63 57V63H57V65H63V71H65V65H71V63H65V57H63Z","fill":"currentColor","key":0}),React.createElement("path",{"opacity":"0.3","d":"M22 14V66","stroke":"currentColor","strokeOpacity":"0.3","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

UploadDocument.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 80 80","fill":"none"};

module.exports = UploadDocument;

UploadDocument.default = UploadDocument;
